import { render, staticRenderFns } from "./ModalCadastrarContaBancaria.vue?vue&type=template&id=18511976"
import script from "./ModalCadastrarContaBancaria.vue?vue&type=script&lang=js"
export * from "./ModalCadastrarContaBancaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports